import {createAsyncThunk} from '@reduxjs/toolkit';
import {ISignUp} from "../../types/authTypes";
import {ThunkConfig} from "../../../config/StateSchema";
import {IErrorAuthRegister} from "../../types/IAuthProfile";
import {removeToken} from "../tokenManagement/tokenManagement";
import {snackbarAction} from "../../../errors/SnackbarSlice";

export const fetchAuthRegister = createAsyncThunk<boolean,
    ISignUp, ThunkConfig<IErrorAuthRegister>>(
        'auth/fetchAuthRegister',
        async (authData, thunkAPI) => {
            const {extra, rejectWithValue, dispatch} = thunkAPI;
            await removeToken()
            let data;

            try {
                const response = await extra.api.post(
                    `/auth/register`,
                    authData);

                data = response;

                if (!response.data.success) {
                    return rejectWithValue(response.data.response.errors)
                }
                return true
            } catch (err) {
                dispatch(snackbarAction.addError('INTERNAL_ERROR'))
                // @ts-ignore
                return rejectWithValue({message: data?.data.codeKey || 'error fetchAuthRegister'});
            }
        },
    );
